import $ from '@nodeModules/jquery';
import '@nodeModules/slick-carousel-latest';

export const initLastSoldEvents = () => {
	const $lastSoldPrevArrowEl = document.querySelector('.last-sold-events__slider-nav-action--prev');
	const $lastSoldNextArrowEl = document.querySelector('.last-sold-events__slider-nav-action--next');

	const $lastSoldEventsSlider = document.querySelector('.last-sold-events__slider');
	if ($lastSoldEventsSlider) {
		$('.last-sold-events__slider').on('init', function(event, slick) {
			$lastSoldEventsSlider.classList.add('last-sold-events__slider--is-initialized');
		}).slick({
			dots: false,
			infinite: true,
			autoplay: true,
			autoplaySpeed: 3000,
			centerMode: false,
			speed: 500,
			rows: 0,
			slidesToShow: 6,
			slidesToScroll: 1,
			swipeToSlide: true,
			prevArrow: $lastSoldPrevArrowEl,
			nextArrow: $lastSoldNextArrowEl,
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 5
					}
				},
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 4
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 3
					}
				},
				{
					breakpoint: 576,
					settings: {
						slidesToShow: 2
					}
				}
			]
		});
	}
};
